import { FilterSections } from "./FilterSections";
import type {
	FilterHandlers,
	FilterSection,
	FilterTranslations,
} from "./types";

type Props = {
	sections: FilterSection[];
	handlers: FilterHandlers;
	translations: FilterTranslations;
	onClear: () => void;
};

/** Desktop map filter column. */
export function FilterRail({
	sections,
	handlers,
	translations,
	onClear,
}: Props) {
	return (
		<div className="flex flex-col gap-6 border-r border-[var(--border-default)] bg-[var(--surface-default)] px-6 pb-10 pt-6">
			<div className="sticky top-0 -mt-6 -mx-6 flex items-baseline justify-between border-b border-[var(--border-subtle)] bg-[var(--surface-default)] px-6 pb-3.5 pt-6">
				<div
					className="text-[19px] font-extrabold tracking-[-0.025em]"
					style={{ fontFamily: "var(--font-display)" }}
				>
					{translations.title}
				</div>
				<button
					type="button"
					onClick={onClear}
					className="text-[13px] font-bold text-[var(--content-muted)]"
				>
					{translations.clear}
				</button>
			</div>
			<FilterSections sections={sections} handlers={handlers} />
		</div>
	);
}
